// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const MsExcelIcon = createSvgIcon(
  <svg width={24} height={24} fill="none" viewBox="0 0 24 24">
    <path
      fill="#185C37"
      d="m14.56 11.7-7.9-1.37V20.5c0 .47.37.84.84.84h13.65c.47 0 .85-.37.85-.84v-3.74z"
    />
    <path
      fill="#21A366"
      d="M14.56 3H7.5a.85.85 0 0 0-.85.84v3.74l7.9 4.59 4.2 1.37L22 12.17V7.58z"
    />
    <path fill="#107C41" d="M6.65 7.58h7.9v4.59h-7.9z" />
    <path
      fill="#000"
      d="M12.31 6.67H6.65v11.45h5.66c.47 0 .85-.37.85-.84V7.51a.85.85 0 0 0-.85-.84"
      opacity={0.1}
    />
    <path
      fill="#000"
      d="M11.85 7.12h-5.2v11.46h5.2c.47 0 .85-.37.85-.84V7.97a.85.85 0 0 0-.85-.85"
      opacity={0.2}
    />
    <path
      fill="#000"
      d="M11.85 7.12h-5.2v10.55h5.2c.47 0 .85-.38.85-.84V7.97a.85.85 0 0 0-.85-.85"
      opacity={0.2}
    />
    <path
      fill="#000"
      d="M11.38 7.12H6.65v10.55h4.73c.47 0 .85-.38.85-.84V7.97a.85.85 0 0 0-.85-.85"
      opacity={0.2}
    />
    <path
      fill="url(#ms-excel_svga)"
      d="M2.85 7.12h8.53c.47 0 .85.38.85.85v8.4c0 .46-.38.84-.85.84H2.85a.85.85 0 0 1-.85-.84v-8.4c0-.47.38-.85.85-.85"
    />
    <path
      fill="#fff"
      d="m4.64 14.9 1.8-2.74-1.65-2.72h1.32l.9 1.74.17.37h.01l.19-.39.96-1.72h1.2l-1.68 2.7L9.6 14.9H8.3l-1.04-1.91-.12-.26h-.01l-.12.25-1.07 1.92z"
    />
    <path fill="#33C481" d="M21.15 3h-6.6v4.58H22V3.84a.85.85 0 0 0-.85-.84" />
    <path fill="#107C41" d="M14.56 12.17H22v4.58h-7.44z" />
    <defs>
      <linearGradient
        id="ms-excel_svga"
        x1={3.78}
        x2={10.31}
        y1={6.47}
        y2={17.95}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#18884F" />
        <stop offset={0.5} stopColor="#117E43" />
        <stop offset={1} stopColor="#0B6631" />
      </linearGradient>
    </defs>
  </svg>,
  "MsExcel",
);
export default MsExcelIcon;
